import React, { useMemo, useState } from 'react';

import { ObjectSchema } from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  AddRolePermissionsFormContext,
  AddRolePermissionsFormState,
  addRolePermissionsFormStateDefault,
  addRolePermissionsSchemaDefault,
} from '@Forms/aviatorPermissions/AddRolePermissionsFormContext';

export const AddRolePermissionsFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<AddRolePermissionsFormState>>>(
    addRolePermissionsSchemaDefault
  );
  const methods = useForm({
    defaultValues: addRolePermissionsFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <AddRolePermissionsFormContext.Provider value={value}>
      {children}
    </AddRolePermissionsFormContext.Provider>
  );
};
